<template>
  <div class="notice">
      <Navbar :selected.sync="selected" :selecteData.sync="selecteData"/>
      <!-- <div> -->
        <!-- NAV1 -->
        
        <!-- <NoticeCard v-show="selected === 0" :noticeData.sync="NoticeData"/> -->
      

        <!-- NAV2 -->
        <!-- <NewCard v-show="selected === 1" :newData.sync="NewData"/> -->
      <!-- </div> -->
      <router-view/>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
// import NoticeCard from '@/components/NoticeCard.vue';
// import NewCard from '@/components/Newitem.vue';
import {NoticeList} from '@/api';
import { MessageBox } from 'mint-ui';

export default {
  name: 'Notice',
  components: {
    Navbar
  },
  data() {
    return {
      selected: 0, // Navbar选择的索引
      selecteData: [{id: 2, name: '新闻', num: 0}, {id: 1, name: '公告', num: 0}], // Navbar数据
      NoticeData: [], // 列表数据（弃用）
      NewData: [] //  列表数据（弃用）
    }
  },
  created() {
    if (this.$route.query.type === 'article' || this.$route.query.type == 7 || this.$route.query.type == 6 || this.$route.query.type == 9) {
      if (this.$route.query.type === 'article') { this.$route.query.type = 7; }
      this.selecteData = [{id: 7, name: '资讯信息', num: 0}, {id: 6, name: '招生院校', num: 0}, {id: 9, name: '专业介绍', num: 0}]
    } else {
      if (!this.$route.query.type) { this.$route.query.type = 3; }
      this.selecteData = [{id: 3, name: '新闻', num: 0}, {id: 4, name: '公告', num: 0}]
    }
    switch (Number(this.$route.query.type)) {
      case 3:
      case 7:
        this.selected = 0
        break;
      case 4:
      case 6:
        this.selected = 1
        break;
      case 9:
        this.selected = 2
        break;
      default:
        break;
    }
  },
  mounted () {
  },
  methods: {
  },
  watch: {
    // Navbar切换
    selected(newVal, oldVal) {
      window.scrollTo(0, 0)
      this.$router.replace({path:"/Notice/NoticeCard", query: {type: this.selecteData[newVal].id} || {}})
    }
  }
};
</script>

<style lang="less" scoped>
  .notice{
    background: #F6F6FA;
    min-height: 100vh;
    .Navbar{
      position: fixed;
      max-width: 640px;
    }
    .NoticeCard, .Newitem{
      padding-top: 0.5rem;
    }
  }
</style> 

